import { lazy } from 'react';

// Route-level code splitting (Sep 2026). Each page is its own chunk, so a tab
// left open across a deploy can ask for a chunk file that no longer exists
// (hosting only keeps the latest build). When that happens, reload ONCE to pick
// up the new index.html; if the import still fails, rethrow so the error
// boundaries show their usual message instead of looping.
const RELOAD_KEY = 'lobi:chunk-reload-at';
const RELOAD_WINDOW_MS = 30000;

export const shouldReloadForChunkError = (lastReloadAt, now) =>
  !lastReloadAt || Number.isNaN(Number(lastReloadAt)) || now - Number(lastReloadAt) > RELOAD_WINDOW_MS;

const readLastReload = () => {
  try {
    return window.sessionStorage.getItem(RELOAD_KEY);
  } catch (e) {
    return null;
  }
};

const lazyWithReload = (importer) =>
  lazy(() =>
    importer().catch((error) => {
      const now = Date.now();
      if (shouldReloadForChunkError(readLastReload(), now)) {
        try {
          window.sessionStorage.setItem(RELOAD_KEY, String(now));
        } catch (e) {
          // sessionStorage unavailable: fall through to the error boundary
          throw error;
        }
        window.location.reload();
        // Keep Suspense showing its fallback while the page reloads
        return new Promise(() => {});
      }
      throw error;
    })
  );

export default lazyWithReload;
